/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_AnalyticsInputs */

const en_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const de_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse`)
};

const fr_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytique`)
};

const es_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis`)
};

const it_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi`)
};

const nl_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse`)
};

const pl_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analityka`)
};

const fi_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytiikka`)
};

const da_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse`)
};

const sv_cookie_consent_analytics = /** @type {(inputs: Cookie_Consent_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analys`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Cookie_Consent_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_analytics = /** @type {((inputs?: Cookie_Consent_AnalyticsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_AnalyticsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_analytics(inputs)
	if (locale === "fr") return fr_cookie_consent_analytics(inputs)
	if (locale === "es") return es_cookie_consent_analytics(inputs)
	if (locale === "it") return it_cookie_consent_analytics(inputs)
	if (locale === "nl") return nl_cookie_consent_analytics(inputs)
	if (locale === "pl") return pl_cookie_consent_analytics(inputs)
	if (locale === "fi") return fi_cookie_consent_analytics(inputs)
	if (locale === "da") return da_cookie_consent_analytics(inputs)
	if (locale === "sv") return sv_cookie_consent_analytics(inputs)
	return en_cookie_consent_analytics(inputs)
});